export default __webpack_public_path__ + "static/media/matic-icon.8a8f08d3.svg";